import {Injectable} from '@angular/core';
import {ProductListComponentService, ViewConfig} from '@spartacus/storefront';
import {ActivatedRoute, Router} from '@angular/router';
import {CurrencyService, LanguageService, ProductSearchService, RoutingService} from '@spartacus/core';

interface SearchCriteria {
  currentPage?: number;
  pageSize?: number;
  sortCode?: string;
  query?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CustomProductListComponentService extends ProductListComponentService {
  constructor(
    protected productSearchService: ProductSearchService,
    protected routing: RoutingService,
    protected activatedRoute: ActivatedRoute,
    protected currencyService: CurrencyService,
    protected languageService: LanguageService,
    protected router: Router, viewConfig: ViewConfig
  ) {
    super(productSearchService, routing, activatedRoute, currencyService, languageService, router, viewConfig);
  }

  sort(sortCode: string): void {
    this.customSetQueryParams({sortCode});
  }

  private customSetQueryParams(queryParams: SearchCriteria): void {
    queryParams.currentPage = 0;
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
    });
  }
}
